import { Card, CardContent } from '@material-ui/core';
import Axios from 'axios';
import React,{useState,useEffect} from 'react'
import {Bar} from 'react-chartjs-2'
import './BarGraph.css'

function BarGraph() {
    const [chartData,setChartData]=useState({});
    useEffect(()=>{
        const getBarData=async ()=>{
            await fetch('https://onevotematters.herokuapp.com/result')
                .then((response)=>response.json())
                .then((data)=>{
                    //pollRes is array of objects pollRes[0]='true'
                    const pollRes=data.data
                    setChartData({
                        labels:['Yes','No','total'],
                        datasets:[{
                            label:'Voting Result',
                            data:[pollRes[0].count,pollRes[1].count,pollRes[0].count+pollRes[1].count],
                            backgroundColor:[
                                'rgba(51,255,0,0.2)',
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(255, 159, 64, 0.2)'
                            ],
                            borderColor: [
                                'rgba(51,255,0,1)',
                                'rgba(255, 99, 132, 1)',
                                'rgba(255, 206, 86, 1)',
                              ],
                            borderWidth:1
                        }]
                    });
                })
        }
       
        getBarData();
    },[])

    const options={
        scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          title:{
              display:false,
              title:'Poll for person Liking covid',
              fontSize:30
          },
          legend:{
              display:true,
              position:'top'
          }
    }
   console.log('Bar graph showing')
    return (
        <>
        <Card className="barStyle">
            <CardContent className="header">
                <h1>Result for the polls </h1>
            </CardContent>
            <Bar height="600px" width="800px" data={chartData} options={options}/>
        </Card>
        </>
    )
}

export default BarGraph
